import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppService } from './app.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [AppService]
})
export class AppComponent  implements OnInit, OnDestroy {
  title = 'udea-Reconocimientos';
  reloadPage = true;

  constructor (private appService: AppService) {}

  ngOnInit() {
    if (localStorage.getItem('cedula') != null) {
       this.reloadPage = false;
    }
    this.appService.getUserData().subscribe((result) => {
      localStorage.clear();
      if (result.data !== undefined) {
        this.saveInStorage(result.data);
        if (this.reloadPage) {
          window.location.reload();
        }
      } else {
         // redireccionar http://www.udea.edu.co/appTools/error.html
          window.location.href = 'https://www.udea.edu.co/appTools/error.html';
      }

    });
  }

  ngOnDestroy() {
    localStorage.removeItem('cedula');
  }
  private saveInStorage (userData) {
    if (typeof(Storage) !== 'undefined') {
      localStorage.removeItem('cedula');
      localStorage.removeItem('usuario');
      localStorage.setItem('usuario', userData.id);
      localStorage.setItem('cedula', userData.cedula);
      // cargar de nuevo el componente o la vista
      // localStorage.setItem('name', userData.name);
  } else {
      // LocalStorage no soportado en este navegador
      console.log('No se soporta LocalStorage');
  }

  }

}
